import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
/*
@deprecated - Please use the ErrorBoundary component
*/
var SentryBoundary = function (_a) {
    var children = _a.children, config = _a.config, isEnabled = _a.isEnabled;
    var isSentryEnabled = config.useSentry && isEnabled && config.sentryDsn;
    useEffect(function () {
        if (isSentryEnabled) {
            Sentry.init({
                release: config.releaseId,
                dsn: config.sentryDsn,
                environment: config.environment,
                integrations: [new Integrations.BrowserTracing()],
                tracesSampleRate: 1.0,
            });
        }
        return function () {
            Sentry.close(0);
        };
    }, [isSentryEnabled, config]);
    if (isSentryEnabled) {
        return React.createElement(Sentry.ErrorBoundary, null, children);
    }
    else {
        return children;
    }
};
export { SentryBoundary };
